import ApiService from "@/core/services/api.service";

const mutations = {
  /**
   * Set is busy
   *
   * @param state
   * @param isBusy
   */
  setTeacherAttendanceTimeBusy(state, isBusy) {
    state.isBusy = isBusy;
  },
};

const state = {
  isBusy: false,
};

const getters = {
  getTeacherAttendanceTimeBusy: (state) => state.isBusy,
};

const actions = {
  updateTeacherAttendanceTime(context, payload) {
    ApiService.setHeader();

    context.commit("setTeacherAttendanceTimeBusy", true);

    return ApiService.post(
      "school/attendance/teacher/manage/time/update",
      payload.form
    )
      .then(() => {
        console.log("Updated ", payload.form);
      })
      .finally(() => context.commit("setTeacherAttendanceTimeBusy", false));
  },
};

export default {
  actions,
  mutations,
  state,
  getters,
};
